var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 31.1667V36.6667C29.3333 37.1529 29.1402 37.6192 28.7964 37.963C28.4525 38.3068 27.9862 38.5 27.5 38.5H7.33333C6.8471 38.5 6.38079 38.3068 6.03697 37.963C5.69315 37.6192 5.5 37.1529 5.5 36.6667V7.33333C5.5 6.8471 5.69315 6.38079 6.03697 6.03697C6.38079 5.69315 6.8471 5.5 7.33333 5.5H27.5C27.9862 5.5 28.4525 5.69315 28.7964 6.03697C29.1402 6.38079 29.3333 6.8471 29.3333 7.33333V12.8333",
    stroke: "#0796A7",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 12.8333C27.5197 12.8333 25.7474 13.3709 24.24 14.3781C22.7325 15.3854 21.5576 16.817 20.8638 18.492C20.17 20.167 19.9885 22.0101 20.3422 23.7882C20.6959 25.5664 21.5689 27.1997 22.8509 28.4817C24.1329 29.7637 25.7662 30.6368 27.5444 30.9904C29.3225 31.3441 31.1656 31.1626 32.8406 30.4688C34.5156 29.775 35.9472 28.6001 36.9545 27.0926C37.9617 25.5852 38.4994 23.8129 38.4994 21.9999M29.3327 12.8333C31.7638 12.8333 34.0954 13.799 35.8145 15.5181C37.5336 17.2372 38.4994 19.5688 38.4994 21.9999M29.3327 12.8333V21.9999M38.4994 21.9999C38.5026 23.8153 37.9667 25.5908 36.9597 27.1012C35.9527 28.6117 34.5199 29.7891 32.8428 30.4843C31.1658 31.1795 29.3202 31.361 27.5399 31.006C25.7595 30.6509 24.1247 29.7752 22.8427 28.4899L29.3327 21.9999M38.4994 21.9999H29.3327",
    stroke: "#2CA9BC",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstIcon2);
export default __webpack_public_path__ + "static/media/inst_icon2.4a127824258d373a4399d872b6b2df9f.svg";
export { ForwardRef as ReactComponent };